import GridTextCell from '../../../cells/GridTextCell';
import GridItemsCell from '../../../cells/GridItemsCell';
import EditorSelectCell from './EditorSelectCell';
import GridSelectCell from '../../../cells/GridSelectCell';

const EditorCells = {
    Text: GridTextCell,
    Items: GridItemsCell,
    Select: GridSelectCell,
    EditorSelect: EditorSelectCell,
};

export default EditorCells;
